module.exports = __webpack_public_path__ + "images/placeholder.jpg?h=0cadc6990742172acdbcf57307273465";


//////////////////
// WEBPACK FOOTER
// ./src/components/public/cart/ItemsList/images/placeholder.jpg
// module id = 2872
// module chunks = 49